module.exports = __webpack_public_path__ + "assets/img/19_884_big.8676db35.jpg";